import { OptionsDropdown } from '$components'
import { DropdownOption } from '$components'

export type OptionsCellProps = {
  options: DropdownOption[]
}

export function OptionsCell({ options }: OptionsCellProps) {
  return (
    <div className="relative z-[2] flex justify-end">
      <OptionsDropdown options={options} />
    </div>
  )
}
